/**
 * Safely execute callback after timeout milliseconds.
 *
 * The native setTimeout() API doesn't handle big timeouts correctly, but the function below patches the limitation.
 */
export const safeSetTimeout = (callback: () => void, timeout: number): number => {
    if (timeout > 1e9) {
        return 0;
    }

    return window.setTimeout(callback, timeout);
};
